var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    fill: "#e6ecff",
    r: 31
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4294ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56.877 50.4748a31.0647 31.0647 0 0 0 -49.7651-.0156 30.9669 30.9669 0 0 0 49.7651.0156z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 22,
    r: 12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2);
export default __webpack_public_path__ + "static/media/profile2.c898c0bbe0195d3da52de412334ea36f.svg";
export { ForwardRef as ReactComponent };